/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { useShallow } from 'zustand/shallow';
import { TUserModalRootTypes, useUserModalRootStore } from './user-modal-root.store';
import DeleteAgentModal from '../../../agent/components/modals/delete-agent-modal';
import DeleteInviteAgentModal from '../../../agent/components/modals/delete-invite-agent-modal';
import InviteAgentModal from '../../../agent/components/modals/invite-agent-modal';
import PendingInviteAgentModal from '../../../agent/components/modals/pending-invite-agent-modal';
import SetAsAdminAgentModal from '../../../agent/components/modals/set-as-admin-modal';
import CreateTeamModal from '../../../team/components/modals/create-team-modal';
import DeleteTeamModal from '../../../team/components/modals/delete-team-modal';
import DeleteAgentOnTeamModal from '../../../team/components/modals/delete-agent-on-team-modal';
import InviteAgentToTeamModal from '../../../team/components/modals/invite-agent-to-team';

const modalMap: Partial<Record<TUserModalRootTypes, React.ComponentType<any>>> = {
  // Agent Modal
  DeleteAgentModal,
  DeleteInviteAgentModal,
  InviteAgentModal,
  PendingInviteAgentModal,
  SetAsAdminAgentModal,

  // Team Modal
  CreateTeamModal,
  DeleteTeamModal,
  DeleteAgentOnTeamModal,
  InviteAgentToTeamModal,
};

// Memoize valid types to avoid recreating on every render
const validUserModalTypes = Object.keys(modalMap) as TUserModalRootTypes[];

const UserModalRoot = memo(() => {
  // Optimized: Only subscribe to modals that belong to this root
  // This prevents re-renders when other modal roots change
  const modals = useUserModalRootStore(
    useShallow((state) => state.modals.filter((modal) => validUserModalTypes.includes(modal.type)))
  );

  // RENDER
  return (
    <>
      {modals.map(({ type, props }, idx) => {
        const ModalComponent = modalMap[type];
        const key = `${type}-${idx + 1}`;

        if (!ModalComponent) return null;

        return <ModalComponent key={key} {...props} />;
      })}
    </>
  );
});
UserModalRoot.displayName = 'UserModalRoot';
export default UserModalRoot;
